class TableOfContents {

  constructor(element) {
    this.element = element
    this.scrollListener()
    this.clickListener()
  }

  scrollListener() {
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    let callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const visible_heading_id = entry.target.querySelector('h2').id
          const activate_toc = this.element.querySelector(`.toc-nav [href="#${visible_heading_id}"]`)
          const previous = this.element.querySelector('.toc-nav__link--current')
          if (previous) {
            previous.classList.remove('toc-nav__link--current')
          }
          activate_toc.classList.add('toc-nav__link--current')
        }
      });
    };

    let observer = new IntersectionObserver(callback, options);

    const container = this.element.querySelector('.toc-modules')
    Array.from(container.children).forEach(child => {
      observer.observe(child)
    })
  }

  clickListener() {
    const nav = this.element.querySelector('.toc-nav')
    nav.addEventListener('click', (ev) => {
      if (ev.target.classList.contains('toc-nav__link')) {
        ev.preventDefault()
        window.location.hash = ev.target.href.split("#")[1]
        const el = this.element.querySelector(`[id="${ev.target.href.split("#")[1]}"]`)
        const parent = el.closest('section')
        parent.scrollIntoView({block: 'center'})
      }
    })

  }


}

export default TableOfContents